function registerFeaturedViewOverrides() {
  if (!window.featuredViewConfig?.events) {
    return;
  }


  window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      return data;
    }
  );

  window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.AFTER_PRODUCTS_FETCHED,
    function (data) {
      const results = data?.payload?.result;

      if (Array.isArray(results)) {
        results.forEach((result) => {
          if (Array.isArray(result.images) && result.images.length) {
            result.images.splice(0, 1);
          }
        });
      }

      return data;
    }
  );

  window.featuredViewConfig.events.registerEvent(
    window.featuredViewConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      return products;
    }
  );
}

// wizzyFeaturedViewLoaded already fired inside wizzyFeaturedView.min.js before this file runs.
// Register immediately when config exists; only fall back to the load event if min.js is not ready yet.
if (window.featuredViewConfig?.events) {
  registerFeaturedViewOverrides();
} else {
  document.addEventListener("wizzyFeaturedViewLoaded", registerFeaturedViewOverrides);
}
